module.exports = __webpack_public_path__ + "img/IMG-20200823-WA0024.47608bb9.jpg";